module.exports = __webpack_public_path__ + "static/media/GoToBookmarks.d8ac8a66.svg";